import SockJS from "sockjs-client";
import { Client, IMessage } from "@stomp/stompjs";
import { BASE_URL } from "../configs/apiConfig";
import { IStoreAutoCloseStatusMessage } from "../typings/interfaces/responses/store-auto-close-message";

const WS_ENDPOINT = `${BASE_URL}/ws`;

export type StoreAutoCloseCallback = (
  payload: IStoreAutoCloseStatusMessage
) => void;

export const connectStoreAutoCloseSocket = (
  storeId: number,
  callback: StoreAutoCloseCallback
) => {
  if (!storeId) {
    throw new Error("Store ID is required to subscribe to auto close updates.");
  }

  const socket = new SockJS(WS_ENDPOINT);
  const client = new Client({
    webSocketFactory: () => socket as any,
    reconnectDelay: 5000,
    onConnect: () => {
      client.subscribe(
        `/topic/store-auto-close/${storeId}`,
        (message: IMessage) => {
          try {
            const payload: IStoreAutoCloseStatusMessage = JSON.parse(
              message.body
            );
            callback(payload);
          } catch (error) {
            console.error("Failed to parse auto close message", error);
          }
        }
      );
    },
    onStompError: (frame) => {
      console.error("STOMP error:", frame.headers["message"]);
    },
    onWebSocketError: (error) => {
      console.error("WebSocket error:", error);
    },
  });

  client.activate();
  return client;
};

